import Link from 'next/link';
import { HiArrowNarrowRight } from 'react-icons/hi';

import FeedbackMessage from '@/tayara-kit/FeedbackMessage';
import Text from '@/tayara-kit/Text';

import LoginScaffold from './LoginScaffold';

export interface AccessScreenProps {
  phoneNumber: string | undefined;
  onClickPasswordMethod: () => void;
  onClickSmsMethod: () => void;
  forgetPassword?: boolean;
  error: string;
}

const AccessScreen = ({
  phoneNumber,
  onClickPasswordMethod,
  onClickSmsMethod,
  forgetPassword,
  error,
}: AccessScreenProps) => (
  <LoginScaffold>
    <div>
      <Text
        text="Confirmer l'accès"
        as="h3"
        className="font-medium text-xl text-gray-700 mt-7"
      />
    </div>
    {/* Actions */}
    <div className="flex flex-col space-y-3 mt-4">
      {/* User has password button */}
      {/* Navigates to enter password screen */}
      {!forgetPassword && (
        <button
          aria-label="Accéder via mon mot de passe"
          onClick={onClickPasswordMethod}
          className="bg-emerald-50 w-full normal-case flex justify-between py-8 px-5 rounded-md items-center active:focus:scale-[0.98] transition-transform
      hover:outline hover:outline-2 hover:outline-offset-0 hover:outline-emerald-500"
        >
          <span className="flex flex-col">
            <Text
              className="text-emerald-500 font-medium text-left"
              text="J'ai déjà un mot de passe"
            />
            <Text
              className="text-sm text-gray-700 font-light"
              text="Accéder via mon mot de passe"
            />
          </span>

          <HiArrowNarrowRight size={26} className="text-emerald-500" />
        </button>
      )}
      {error && <FeedbackMessage text={error} />}

      {/* User has no password */}
      {/* Navigates to SMS screen */}
      <Link passHref href={{ query: { screen: 'sms' } }}>
        <button
          aria-label="Confirmer par SMS"
          onClick={onClickSmsMethod}
          className="bg-blue-50 w-full normal-case flex justify-between py-8 px-5 rounded-md items-center active:focus:scale-[0.98] transition-transform
      hover:outline hover:outline-2 hover:outline-offset-0 hover:outline-blue-500"
        >
          <span className="flex flex-col items-start">
            <Text
              className="text-blue-500 font-medium text-left"
              text="Confirmer par SMS"
            />
            <Text
              className="text-sm text-gray-700 font-light"
              text={`Insérer le code SMS reçu sur le numéro`}
            />
            <Text
              className="text-sm text-gray-700 font-light"
              text={`** *** ${phoneNumber?.substr(-3)}`}
            />
          </span>

          <HiArrowNarrowRight size={26} className="text-blue-500" />
        </button>
      </Link>
    </div>
    <LoginScaffold.AccessFooter />
  </LoginScaffold>
);

export default AccessScreen;
